import { LIST_CATEGORY_GROUPS_PAGINATED } from '../config';

const initialState = { data: [], total: 0, page: 1, limit: 10 };

export default function (state = initialState, action) {
    switch (action.type) {
        case LIST_CATEGORY_GROUPS_PAGINATED:
            return action.payload;
        default:
            return state;
    }
}
